<mat-card class="cardWithShadow">
    <mat-card-header>
        <mat-card-title>
            Immissione in rete
        </mat-card-title>
    </mat-card-header>
    <mat-card-content class="text-center">

        <circle-progress class="score-gauge" [percent]="chart.percent" [toFixed]="chart.toFixed" [radius]="chart.radius"
            [space]="chart.space" [title]="chart.title" [subtitle]="chart.subtitle" [showTitle]="chart.showTitle"
            [titleFontSize]="chart.titleFontSize" [titleColor]="chart.titleColor"
            [subtitleFontSize]="chart.subtitleFontSize" [subtitleColor]="chart.subtitleColor"
            [showUnits]="chart.showUnits" [outerStrokeWidth]="chart.outerStrokeWidth"
            [outerStrokeColor]="chart.outerStrokeColor" [innerStrokeWidth]="chart.innerStrokeWidth"
            [innerStrokeColor]="chart.innerStrokeColor" [showBackground]="chart.showBackground"
            [responsive]="chart.responsive">
        </circle-progress>
        <div class="d-flex align-items-center justify-content-between">
            <span class="f-s-16 f-w-500">Di cui condivisa</span>
            <h5 class="f-s-16 m-0 f-w-500">{{ shared }} {{ type ==='history' ? 'kWh' : 'kW' }}</h5>
        </div>
    </mat-card-content>
</mat-card>